export abstract class PaginationStrategy {
    abstract recalculate(numberOfItems: number);
    abstract getPageCount(): number;
    abstract getItemsPerPage(): number;

    getPageStart(pageNumber: number): number {
        return Math.max(this.getItemsPerPage() * pageNumber, 0);
    }

    getPageEnd(pageNumber: number): number {
        return this.getPageStart(pageNumber) + this.getItemsPerPage();
    }
}
